

export const REGISTRATION_UPDATE_EMAIL = "REGISTRATION_UPDATE_EMAIL";
export const REGISTRATION_UPDATE_ADVISOR_DETAILS = "REGISTRATION_UPDATE_ADVISOR_DETAILS";
export const MENU_REGISTRATION = "MENU_REGISTRATION";
export const MENU_PLANNING = "MENU_PLANNING";
export const MENU_PLANCOMPARE = "MENU_PLANCOMPARE";
export const ADMIN_LOGIN_PAGE = "ADMIN_LOGIN_PAGE";
export const ADMIN_PAGE = "ADMIN_PAGE";
export const MENU_INTRODUCTION = "MENU_INTRODUCTION";
export const CLIENTINFO_UPDATE = "CLIENTINFO_UPDATE";
export const ACCOUNT_UPDATE = "ACCOUNT_UPDATE";
export const ASSET_UPDATE = "ASSET_UPDATE";
export const IP7PERCENTAGE_UPDATE = "IP7PERCENTAGE_UPDATE";
export const INDEXARCHIEVERPERCENTAGE_UPDATE = "INDEXARCHIEVERPERCENTAGE_UPDATE";
export const VALIDATE_PLANINFO = "VALIDATE_PLANINFO";
export const UPDATE_ALLOCATION_ID = "UPDATE_ALLOCATION_ID";
export const UPDATE_ALLOCATION_TYPE = "UPDATE_ALLOCATION_TYPE";
export const UPDATE_INDEX_ALLOCATIONS = "UPDATE_INDEX_ALLOCATIONS";
export const UPDATE_INDEX_ALLOCATIONS_RILA = "UPDATE_INDEX_ALLOCATIONS_RILA";
export const CREATE_PLAN_OBJECT = "CREATE_PLAN_OBJECT";
export const UPDATE_MARKET_CONDITION_TYPE = "UPDATE_MARKET_CONDITION_TYPE";
export const UPDATE_CONDITION_EQUITY = "UPDATE_CONDITION_EQUITY";
export const UPDATE_CONDITION_INTEREST = "UPDATE_CONDITION_INTEREST";
export const SET_IP7_EDITABLE = "SET_IP7_EDITABLE";
export const SET_IP7_NONEDITABLE = "SET_IP7_NONEDITABLE";
export const UPDATE_IP7_ALLOCATION = "UPDATE_IP7_ALLOCATION";
export const VALIDATE_IP7_ALLOCATIONS = "VALIDATE_IP7_ALLOCATIONS";
export const UPDATE_COVER_PAGE = "UPDATE_COVER_PAGE";
export const UPDATE_ADVISOR_DATA = "UPDATE_ADVISOR_DATA";
export const UPDATE_CLIENT_ID = "UPDATE_CLIENT_ID";
export const SET_ERROR_STATE = "SET_ERROR_STATE";
export const CLEAR_ERROR_STATE = "CLEAR_ERROR_STATE";
export const SET_LOADING = "SET_LOADING";
export const CLEAR_LOADING = "CLEAR_LOADING";
export const UPDATE_ALLOCATION_LIST = "UPDATE_ALLOCATION_LIST";
export const UPDATE_DEFAULT_ASSETS = "UPDATE_DEFAULT_ASSETS";
export const UPDATE_STANDARD_PLAN = "UPDATE_STANDARD_PLAN";
export const UPDATE_IP7_PLAN = "UPDATE_IP7_PLAN";
export const SUBMITTED_PLAN_INFO = "SUBMITTED_PLAN_INFO";
export const CLEAR_PLANINFO_SUBMITTED = "CLEAR_PLANINFO_SUBMITTED";
export const SET_STANDARD_PLANID = "SET_STANDARD_PLANID";
export const SET_IP7PLAN_PLANID = "SET_IP7PLAN_PLANID";
export const REGISTRATION_UPDATE_EMAIL_EXISTS = "REGISTRATION_UPDATE_EMAIL_EXISTS";
export const RESET_MARKET_CONDITIONS = "RESET_MARKET_CONDITIONS";
export const SET_DOWNLOAD_URL = "SET_DOWNLOAD_URL";
export const CANCEL_IP7_ALLOCATION_CHANGE = "CANCEL_IP7_ALLOCATION_CHANGE";
export const SAVE_BACKUP_ALLOCATIONS = "SAVE_BACKUP_ALLOCATIONS";
export const LOCK_REGISTRATION = "LOCK_REGISTRATION";
export const UNLOCK_REGISTRATION = "UNLOCK_REGISTRATION";
export const BACKUP_MARKET_CONDITIONS = "BACKUP_MARKET_CONDITIONS";
export const SET_AUTHORIZED = "SET_AUTHORIZED";
export const SET_COMPANY_NAME = "SET_COMPANY_NAME";
export const SET_ADMIN_PAGE = "SET_ADMIN_PAGE";
export const SET_SELECTED_INDEX_PROTECTOR = "SET_SELECTED_INDEX_PROTECTOR";
export const GET_PRODUCTS_CONFIGURATION = "GET_PRODUCTS_CONFIGURATION";
export const GET_INSTITUTE_PRODUCT_LIST = "GET_INSTITUTE_PRODUCT_LIST";
export const GET_PRODUCT_RATES_LIST = "GET_PRODUCT_RATES_LIST";
export const ADMIN_SUCCESSFULY_LOGGED_IN = "ADMIN_SUCCESSFULY_LOGGED_IN";
export const ADMIN_SUCCESSFULY_LOGGED_OUT = "ADMIN_SUCCESSFULY_LOGGED_OUT";
export const ADMIN_PAGE_SET_SAVED = "ADMIN_PAGE_SET_SAVED";
export const SET_ADMIN_LOGIN_ERROR = "SET_ADMIN_LOGIN_ERROR";
export const CLEAR_ADMIN_LOGIN_ERROR = "CLEAR_ADMIN_LOGIN_ERROR";
export const SET_BYPASS_INTRODUCTION = "SET_BYPASS_INTRODUCTION";
export const UPDATE_IS_VALID = "UPDATE_IS_VALID";


// WEBPACK FOOTER //
// ./src/store/actions.js